export const ERR_FIELD_BLOCK_NO = 'Block no.'
export const ERR_FIELD_COMPANY_NAME = 'Company name'
export const ERR_FIELD_CONTACT_NAME = "Contact person's name"
export const ERR_FIELD_CONTACT_NUMBER = 'Contact number'
export const ERR_FIELD_EMAIL = 'Email'
export const ERR_FIELD_POSTAL_CODE = 'Postal code'
export const ERR_FIELD_STREET_NAME = 'Street name'
export const ERR_FIELD_UEN = 'UEN'
export const ERR_UNEXPECTED =
  'An unexpected error has occurred. Please try again later.'
export const ERR_REQUIRED = 'cannot be blank.'
export const ERR_INVALID = 'is invalid. Please enter a valid'
export const UNAUTHORIZED_MSG =
  'You did not have the right permissions to access the page.'
export const INVALID_SIGNIN = 'You are not logged in.'
export const BACKEND_ERROR_LOOKUP = {
  DUPLICATED_EMAIL: 'duplicated object: email should be unique',
  DUPLICATED_UEN: 'duplicated object: uen should be unique'
}
export const ERROR_ALLOCATION_EXCEEDED =
  'Allocation for this member exceeds total available amount in bundle. Please re-allocate or purchase more add-ons.'
export const ERR_USER_DETAILS = 'There is a problem getting user details'
export const ERR_ACCESS_DATA =
  'We are unable access your data at the moment, please try again later'
export const ERR_UPDATE_USER =
  'There was a problem updating your user information, please try again later'
